"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _faTimes = require("@fortawesome/free-solid-svg-icons/faTimes");
var _DateRangePicker = require("./DateRangePicker.styles");
var _customHooks = require("../../../customHooks");
var _hooks = require("./hooks");
var _Input = require("../../Input");
var _IconButton = require("../../button/IconButton");
var _Typography = require("../../Typography");
var _DatePicker = require("../DatePicker");
var _components = require("./components");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var rangeLabels = ['Today', 'Yesterday', 'This week', 'Last week', 'This month', 'Last month'];
var DateRangePicker = /*#__PURE__*/(0, _react.memo)(function (props) {
  var _range$0$format, _range$, _propsClasses$input, _range$1$format, _range$2, _propsClasses$input2;
  var value = props.value,
    label = props.label,
    testId = props.testId,
    variant = props.variant,
    onChange = props.onChange,
    _props$language = props.language,
    language = _props$language === void 0 ? 'en' : _props$language,
    _props$labelTo = props.labelTo,
    labelTo = _props$labelTo === void 0 ? 'To' : _props$labelTo,
    _props$fieldName = props.fieldName,
    fieldName = _props$fieldName === void 0 ? '' : _props$fieldName,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$labelFrom = props.labelFrom,
    labelFrom = _props$labelFrom === void 0 ? 'From' : _props$labelFrom,
    _props$confirmLabel = props.confirmLabel,
    confirmLabel = _props$confirmLabel === void 0 ? 'Ok' : _props$confirmLabel,
    _props$cancelLabel = props.cancelLabel,
    cancelLabel = _props$cancelLabel === void 0 ? 'Cancel' : _props$cancelLabel,
    propsClasses = props.classes,
    _props$format = props.format,
    format = _props$format === void 0 ? _DatePicker.datepickerFormat : _props$format,
    _props$staticRangeLab = props.staticRangeLabels,
    staticRangeLabels = _props$staticRangeLab === void 0 ? rangeLabels : _props$staticRangeLab;
  var _useDateRangeState = (0, _hooks.useDateRangeState)(fieldName, onChange),
    dateState = _useDateRangeState.dateState,
    range = _useDateRangeState.state.range,
    hoverDay = _useDateRangeState.hoverDay,
    anchorEl = _useDateRangeState.anchorEl,
    setRange = _useDateRangeState.setRange,
    changeDate = _useDateRangeState.changeDate,
    setHoverDay = _useDateRangeState.setHoverDay,
    handleClose = _useDateRangeState.handleClose,
    clearToValue = _useDateRangeState.clearToValue,
    clearFromValue = _useDateRangeState.clearFromValue,
    handleToInputClick = _useDateRangeState.handleToInputClick,
    handleFromInputClick = _useDateRangeState.handleFromInputClick,
    handleDiscardChanges = _useDateRangeState.handleDiscardChanges;
  var classes = (0, _DateRangePicker.useStyles)();
  var previousValue = (0, _customHooks.usePrevious)(value);
  (0, _react.useEffect)(function () {
    if (previousValue && value && value !== previousValue) {
      setRange(value, false);
    }
  }, [value, previousValue, setRange]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    variant: "caption"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.content, _defineProperty({}, classes.vertical, variant === 'vertical'))
  }, /*#__PURE__*/_react["default"].createElement(_Input.Input, {
    label: labelFrom,
    testId: "".concat(testId, "-from"),
    value: (_range$0$format = (_range$ = range[0]) === null || _range$ === void 0 ? void 0 : _range$.format(format)) !== null && _range$0$format !== void 0 ? _range$0$format : '',
    InputProps: (0, _react.useMemo)(function () {
      return {
        endAdornment: range[0] && /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
          onClick: clearFromValue,
          icon: _faTimes.faTimes
        }))
      };
    }, [clearFromValue, range]),
    onFocus: handleFromInputClick,
    className: (0, _classnames["default"])(classes.input, (_propsClasses$input = propsClasses === null || propsClasses === void 0 ? void 0 : propsClasses.input) !== null && _propsClasses$input !== void 0 ? _propsClasses$input : '')
  }), /*#__PURE__*/_react["default"].createElement(_Input.Input, {
    label: labelTo,
    testId: "".concat(testId, "-to"),
    onFocus: handleToInputClick,
    value: (_range$1$format = (_range$2 = range[1]) === null || _range$2 === void 0 ? void 0 : _range$2.format(format)) !== null && _range$1$format !== void 0 ? _range$1$format : '',
    InputProps: (0, _react.useMemo)(function () {
      return {
        endAdornment: range[1] && /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
          onClick: clearToValue,
          icon: _faTimes.faTimes
        }))
      };
    }, [clearToValue, range]),
    className: (0, _classnames["default"])(classes.input, (_propsClasses$input2 = propsClasses === null || propsClasses === void 0 ? void 0 : propsClasses.input) !== null && _propsClasses$input2 !== void 0 ? _propsClasses$input2 : '')
  })), /*#__PURE__*/_react["default"].createElement(_components.DateRangePickerView, {
    dateRange: dateState.range,
    range: range,
    format: format,
    testId: testId,
    anchorEl: anchorEl,
    hoverDay: hoverDay,
    language: language,
    onSelect: setRange,
    onHover: setHoverDay,
    onChange: changeDate,
    onClose: handleClose,
    handleDiscardChanges: handleDiscardChanges,
    currentInput: dateState.currentInput,
    staticRangeLabels: staticRangeLabels,
    confirmLabel: confirmLabel,
    cancelLabel: cancelLabel
  }));
});
exports.DateRangePicker = DateRangePicker;